var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1809)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7008 14H16.2348V23.0895H12.25V26.3463H16.2348V29.764H12.25V33.019H16.2348V42H27.7008C34.5958 42 39.8423 38.3337 41.86 33.0207H45.5V29.7658H42.658C42.728 29.1883 42.763 28.5967 42.763 27.9982V27.9177C42.763 27.3857 42.735 26.8608 42.6807 26.3463H45.5V23.0912H41.9282C39.9613 17.6995 34.6745 14 27.7008 14ZM38.3478 33.0207C36.5855 36.652 32.7985 39.0793 27.7008 39.0793H19.4408V33.0207H38.3478ZM39.3347 26.3463C39.4082 26.8835 39.4468 27.4347 39.4468 27.9982V28.077C39.4468 28.6528 39.4065 29.2145 39.3295 29.764H19.439V26.3463H39.3365H39.3347ZM27.7025 16.9155C32.823 16.9155 36.6222 19.4075 38.374 23.0895H19.439V16.9155H27.699H27.7025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/DAI.8be2201a893bdaed56e5e7be2d9dff19.svg";
export { ForwardRef as ReactComponent };